import { mfaApi } from './mfaApi'
import {
  MFAChallengeDTO,
  MFAChallengePayload,
  MFAChallengeVerifyDTO,
  MFAChallengeVerifyPayload,
} from './mfaTypes'

async function startMfa(
  payload: MFAChallengePayload,
): Promise<MFAChallengeDTO> {
  return mfaApi.startMfa(payload)
}

async function verifyMfa(
  payload: MFAChallengeVerifyPayload,
): Promise<MFAChallengeVerifyDTO> {
  return mfaApi.verifyMfa(payload)
}

export const mfaServices = {
  startMfa,
  verifyMfa,
}
